import React, { Component } from "react";
import { NavItem, Nav } from "react-bootstrap";
import { withRouter } from 'react-router-dom'
import { clearCredentials } from './../../helpers/auth/storageAuth'

class AdminNavbarLinks extends Component {

  onSignOut = () => {
    clearCredentials()
    this.props.history.push('/')
  }

  render() {
    return (
      <div>
        <Nav>
          <NavItem eventKey={1} href="#">
            <p className="hidden-lg hidden-md">Dashboard</p>
          </NavItem>
        </Nav>
        <Nav pullRight>
          <NavItem eventKey={2} href="#">
            <button 
              onClick={this.onSignOut}
              style={{
                background: 'none',
                color: 'inherit',
                border: 'none',
                padding: 0,
                font: 'inherit',
                cursor: 'pointer',
                outline: 'inherit'}}
            >
            Sign Out
            </button>
          </NavItem>
        </Nav>
      </div>
    );
  }
}

export default withRouter(AdminNavbarLinks);
